import { Link } from 'react-router-dom';
import { AI_TOOLS, PLAN_ORDER, PLANS } from '../plans';
import { Reveal, TiltCard } from '../components/motion';

export default function BusinessGrowthPlans() {
  return (
    <section className="pricing growth-pricing" id="pricing">
      <div className="pricing-inner">
        <Reveal>
          <div className="section-tag">BUSINESS GROWTH PLANS</div>
          <h2 className="pricing-title">Tools that grow with<br /><span className="gradient-text">your customer pipeline.</span></h2>
          <p className="pricing-sub">Start with a professional presence, then add follow-up, automation, and a custom revenue system as your business grows.</p>
        </Reveal>
        <div className="pricing-grid">
          {PLAN_ORDER.map(planId => {
            const plan = PLANS[planId];
            const aiTools = AI_TOOLS.filter(tool => tool.minimum === planId);
            const href = plan.consultation ? 'mailto:host@loadedloaded.com?subject=Business%20Growth%20Consultation' : `/signup?plan=${planId}`;
            const Action = plan.consultation ? 'a' : Link;
            return <TiltCard as="article" intensity={3} lift={4} className={`pricing-card glass ${plan.badge ? 'pricing-card-featured' : ''}`} key={planId}>
              {plan.badge && <div className="plan-badge">{plan.badge}</div>}
              <div className="plan-tag">{plan.name}</div>
              <div className="plan-price"><span className="plan-amount">${plan.price}</span><span className="plan-period">/month</span></div>
              <p className="plan-desc">{plan.tagline}</p>
              <div className="plan-list-label">Included tools</div>
              <ul className="plan-features">{plan.features.map(feature => <li key={feature}><span className="feat-check">✓</span>{feature}</li>)}</ul>
              <div className="plan-list-label">AI Studio</div>
              <ul className="plan-features">{aiTools.map(tool => <li key={tool.id}><span className="feat-check">✓</span>{tool.name}</li>)}</ul>
              <div className="plan-list-label">Monthly capacity</div>
              <ul className="plan-features plan-limits">{plan.limits.map(limit => <li key={limit}><span className="feat-check">✓</span>{limit}</li>)}</ul>
              {plan.service && <><div className="plan-list-label">Monthly service review</div><ul className="plan-features">{plan.service.map(item => <li key={item}><span className="feat-check">✓</span>{item}</li>)}</ul></>}
              <p className="plan-best"><strong>Best for:</strong> {plan.audience}</p>
              <Action to={plan.consultation ? undefined : href} href={plan.consultation ? href : undefined} className={`plan-btn ${plan.badge ? 'plan-btn-primary' : 'plan-btn-outline'}`}>{plan.cta}</Action>
            </TiltCard>;
          })}
        </div>
      </div>
    </section>
  );
}